$(document).ready(function () {

    $.blockUI.defaults.css = {
        border: 0,
        padding: 0,
        backgroundColor: 'transparent',
        color: '#757575'
    };
    $.blockUI.defaults.overlayCSS = {
        backgroundColor: '#fff',
        opacity: 0.9,
        cursor: 'wait'
    };

    PNotify.prototype.options.styling = "bootstrap3";

    /**
     * Ajustea a altura dos paineis com os endereços
     */
    var $addressPanels = $(".equals .panel .panel-body");
    var heights = $addressPanels.map(function () {
        return $(this).height();
    }).get();

    if (heights.length > 0) {
        var maxHeight = Math.max.apply(null, heights);
        $addressPanels.height(maxHeight);
    }

    if (pageName == 'checkout-endereco') {
        var panelHeight = $(".equals .panel:first").height();
        if (!panelHeight) {
            panelHeight = 250;
        }

        var $btnAddAddress = $(".btn.add-address");
        var paddingH = (panelHeight - $btnAddAddress.height()) / 2;
        $btnAddAddress.css({
            'transition': 'all 0.4s, padding 0s',
        })
        $btnAddAddress.css({
            'padding-top': paddingH + 'px',
            'padding-bottom': paddingH + 'px',
        });
    }

    // Home
    if (pageName == 'home') {

        setTimeout(function () {

            $("#carousel-marca").owlCarousel({
                itemsDesktop: [1920, 10],
                itemsDesktopSmall: [1300, 8],
                itemsTablet: [1024, 6],
                itemsMobile: [768, 3],
                navigation: true,
                navigationText: false,
                pagination: false,
                slideSpeed: 300,
                paginationSpeed: 400,
                autoPlay: 4000000,
                addClassActive: true,
                rewindNav: false,
                lazyLoad: true,
                scrollPerPage: true
            });

            $("#advantage-banner").owlCarousel({
                pagination: false,
                navigation: false,
                slideSpeed: 300,
                paginationSpeed: 400,
                singleItem: true,
                autoPlay: true,
                lazyLoad: true,
            });

            $("#carousel-banner").owlCarousel({
                navigation: true,
                slideSpeed: 300,
                paginationSpeed: 400,
                singleItem: true,
                autoPlay: 4000,
                lazyLoad: true,
                pagination: false,
                navigationText: false,
            });

            $(".carousel-products").each(function () {
                $(this).owlCarousel({
                    // xl
                    itemsDesktop: [1920, $(this).data('xl-columns')],
                    // lg
                    itemsDesktopSmall: [1600, $(this).data('lg-columns')],
                    // md
                    itemsTablet: [1200, 4],
                    // sm
                    itemsTabletSmall: [992, 3],
                    // xs
                    itemsMobile: [767, 2],
                    navigation: true,
                    navigationText: false,
                    slideSpeed: 300,
                    paginationSpeed: 400,
                    autoPlay: 4000000,
                    addClassActive: true,
                    rewindNav: false,
                    lazyLoad: true,
                    scrollPerPage: true
                });
            });


            $("#carousel-parceiros").owlCarousel({
                itemsDesktop: [1920, 4],
                itemsDesktopSmall: [1300, 4],
                itemsTablet: [1024, 2],
                itemsMobile: [768, 1],
                navigation: false,
                navigationText: false,
                pagination: true,
                slideSpeed: 300,
                paginationSpeed: 400,
                autoPlay: 4000000,
                addClassActive: true,
                rewindNav: false,
                lazyLoad: true,
                scrollPerPage: true
            });
        }, 200);
    }

    // Empresa
    if (pageName == 'empresa') {

        var owlCarouselAbout = $("#owl-about").owlCarousel({
            navigation: false,
            slideSpeed: 300,
            paginationSpeed: 400,
            items: 4,
            itemsDesktop: [1186, 4],
            itemsDesktopSmall: [978, 3],
            itemsTablet: [600, 1],
            lazyLoad: true,
        });

        $(function () {

            var pswp = $(".pswp")[0];
            var slides = [];
            var photoSwipe;

            function getSlideDimensions(slide, photoSwipe) {
                if (!slide.doGetSlideDimensions)
                    return;

                var isPrefetch = (typeof photoSwipe == "undefined");
                var img = new Image();

                $(img).on("error", function (evt) {
                    if (!isPrefetch)
                        slide.doGetSlideDimensions = false;
                });

                $(img).on("load", function (evt) {
                    slide.doGetSlideDimensions = false;
                    slide.w = img.naturalWidth;
                    slide.h = img.naturalHeight;
                    if (!isPrefetch) {
                        photoSwipe.invalidateCurrItems();
                        photoSwipe.updateSize(true);
                    }
                });

                img.src = slide.src;
            }

            function getThumbBounds(index) {
                var slide = slides[index];
                var thumbnail = slide.anchor.find("img")
                    , thumbOffset = thumbnail.offset()
                    , thumbWidth = thumbnail.width();
                return {
                    x: thumbOffset.left,
                    y: thumbOffset.top,
                    w: thumbWidth
                };
            }

            $("#owl-about .item a").each(function (ix, el) {
                var $anchor = $(this);
                var size = ($anchor.data("size") || "0x0").split("x");
                var slide = {
                    anchor: $anchor,
                    src: $anchor.attr("href"),
                    w: size[0],
                    h: size[1]
                };

                slide.doGetSlideDimensions = (slide.w == 0 || slide.h == 0);

                slides.push(slide);

                $anchor.on("click", function (evt) {
                    evt.preventDefault();

                    var options = {
                        index: ix
                        , bgOpacity: 0.90
                        , showHideOpacity: false
                        , getThumbBoundsFn: getThumbBounds
                        , preload: [5, 5]
                    }

                    photoSwipe = new PhotoSwipe(pswp, PhotoSwipeUI_Default, slides, options);

                    photoSwipe.listen("gettingData", function (index, slide) {
                        if (slide.doGetSlideDimensions) {
                            setTimeout(
                                // use setTimeout to run in the event loop
                                function () {
                                    getSlideDimensions(slide, photoSwipe);
                                }
                                , 300
                            );
                        }
                    }); // .listen(gettingData)

                    photoSwipe.listen("imageLoadComplete", function (index, slide) {
                        if (slide.doGetSlideDimensions)
                            getSlideDimensions(slide, photoSwipe);
                    });

                    photoSwipe.listen('beforeChange', function () {
                        owlCarouselAbout.trigger('owl.goTo', photoSwipe.getCurrentIndex());
                    });

                    photoSwipe.init();

                    window.photoSwipe = photoSwipe;
                });
            }); // .each()

            var i;
            for (i in slides) {

                setTimeout(
                    getSlideDimensions
                    , 1000 + i * 20
                    , slides[i]
                );
            } // for-in
            //*/
        });
    }

    // Cadastro
    if (pageName == 'cadastro') {

        var $tipoPessoaRadio = $('[name="pessoa_tipo"]');

        if ($tipoPessoaRadio.length > 0) {
            var $pfContainer = $('#pessoa_fisica_container');
            var $pjContainer = $('#pessoa_juridica_container');

            $tipoPessoaRadio.on('click', function () {
                if ($(this).val() == 'pessoa_fisica') {
                    $pjContainer.hide();
                    $pfContainer.show();
                } else {
                    $pfContainer.hide();
                    $pjContainer.show();
                }
            });

            $('[name="pessoa_tipo"]:checked').trigger('click');
        }
    }
    ;

    // Carrinho
    if (pageName == 'carrinho') {

        var initPluginsCarrinho = function () {
            initTouchSpin();
            initMasks();
            loadCartQuantity();
            disableFormOnSubmit();
            initBannerCarrinho();
        };

        initBannerCarrinho();

        // Atualizar quantidade
        //window.reloadTimer;
        $('body').on('change', '.product-qtd', function () {

            // Como é necessários dois inputs, ele altera o valor dos dois inputs quando um muda
            var valor = this.value;
            var data_item_id = $(this).data('item-id');
            $('[data-item-id="' + data_item_id + '"]').attr('value', valor);

            var bodyHeight = $(window).innerHeight() + 'px',
                form = $(this).parents('form'),
                action = form.attr('action'),
                data = form.serialize();

            $('body').css('cursor', 'wait');

            clearTimeout(window.reloadTimer);
            window.reloadTimer = setTimeout(function () {
                $.post(action, data, function () {
                    $('main').load(window.location.href + ' .update-onload', function () {
                        $('body').css('cursor', 'default');
                        initPluginsCarrinho();
                    });
                });
            }, 300);
        });

        $('body').on('click', '#cancelar-simulacao-frete', function (e) {
            e.preventDefault();
            $('body').css('cursor', 'wait');
            var action = $(this).attr('href');
            $.get(action, function () {
                $('main').load(window.location.href + ' .update-onload', function () {
                    $('body').css('cursor', 'default');
                    initPluginsCarrinho();
                });
            });
        });

        $('.form-frete').on('shown.bs.collapse', function () {
            $('#frete-cep').val('').focus();
        })
    }
    ;

    // Checkout pagamento
    if (pageName == 'checkout-pagamento') {

        /**
         * Valida o cartão de crédito
         */
        validateCreditCard();

        /**
         * Executa quando um panel é aberto.
         */
        function fnShownCollapse(e) {
            var body = $('html,body');
            var panel = $(e.target).parents('.panel:first');
            if (panel.length) {
                body.stop().animate({scrollTop: panel.offset().top}, 500);
            }
        }

        /**
         * Executa quando um panel é fechado.
         */
        function fnHiddenCollapse(e) {
        }

        // Inicializa os eventos de abertura e fechamento dos panels para a escolha da forma de pagamento.
        $('.accordion-payment-type .panel .panel-collapse').on('hidden.bs.collapse', fnHiddenCollapse);
        $('.accordion-payment-type .panel .panel-collapse').on('shown.bs.collapse', fnShownCollapse);

        // Eventos na alteração da forma de entrega
        $('body').on('change', 'input[name="frete"]', function () {
            /**
             * Caso seja retirada na loja, adiciona o id do local da retirada.
             * Do contrário, o remove.
             */
            var retirada_id = ($(this).val() == 'retirada_loja') ? $(this).data('local-id') : "";
            $('#pedido_retirada_loja').val(retirada_id);
        });

        /**
         * Ao efetuar o submit do formulário de pagamento (seja cartão, boleto, pagseguro, outros)
         * o sistema verifica se existe um meio de entrega e se algum está preenchido.
         * Caso não esteja, apresenta uma mensagem de erro de informando o cliente para que selecione
         * um dos itens referentes ao meio de entrega.
         */
        $('body').on('click', '.confirm-payment', function (e) {
            if ($('input[name="frete"]').length > 0 && $('input[name="frete"]:checked').length == 0) {
                $('#shipping-error').show();
                $("body").animate({
                    top: $('#shipping-type').offset().top
                }, 300);
                e.preventDefault();
                return false;
            }
        });

    }
    ;

    if (pageName == 'carrinho' || pageName == 'checkout-pagamento') {

        var $fnEnableOrDisableSubmitBtn = function ($input) {
            if ($input.val() != '' && $input.val() == $input.data('value')) {
                $input.next('.btn').attr('disabled', true)
            } else {
                $input.next('.btn').attr('disabled', false);
            }
        };

        var $body = $('body');

        var $cupomInput = $('[name="cupom_desconto"]');
        $fnEnableOrDisableSubmitBtn($cupomInput);
        $body.on('keyup', '[name="cupom_desconto"]', function () {
            $fnEnableOrDisableSubmitBtn($cupomInput);
        });

        var $cepInput = $('[name="CEP"]');
        $fnEnableOrDisableSubmitBtn($cepInput);
        $body.on('keyup', '[name="CEP"]', function () {
            $fnEnableOrDisableSubmitBtn($cepInput);
        });
    }

    // Minha Conta - Avaliações
    if (pageName == 'minha-conta-avaliacoes') {
        initRating();
    }

    // Produto Avaliação
    if (pageName == 'produto-avalie') {
        initRating();
        $('.rating').val('').show();
    }
    ;

    // Produto detalhes
    if (pageName == 'produto-detalhes') {

        /** Floating Products */
        var $floatingProducts = $('#floating-products');
        if ($floatingProducts.length == 1) {

            var $floatingProductsWrapper = $('.foto_preco');
            var swiperFloating;

            var initSwiper = function () {
                console.log('initSwiper');
                swiperFloating = new Swiper('.swiper-nested-2', {
                    mode: 'vertical',
                    slidesPerView: 3,
                    nextButton: '.arrows.down',
                    prevButton: '.arrows.up',
                    mousewheelControl: true,
                    onInit: function (swiper) {
                        if (swiper.slides.length > 3) {
                            $(swiper.container).parent().find('.arrows.up, .arrows.down').show();
                        }

                        $floatingProducts.css('opacity', 1)
                            .on('click', '.arrows.up', function (e) {
                                e.preventDefault();
                                swiperFloating.swipePrev()
                            })
                            .on('click', '.arrows.down', function (e) {
                                e.preventDefault();
                                swiperFloating.swipeNext();
                            });
                    },
                });
            };

            var timer_affixFloatingProductsWrapper;
            var affixFloatingProductsWrapper = function () {
                clearTimeout(timer_affixFloatingProductsWrapper);
                timer_affixFloatingProductsWrapper = setTimeout(function() {
                    console.log('affixFloatingProductsWrapper')
                    $(window).off('.affix')
                    $floatingProducts.removeData('bs.affix').removeClass('affix affix-top affix-bottom');

                    $floatingProducts.affix({
                        offset: {
                            top: $floatingProductsWrapper.offset().top - 5,
                            bottom: function() {
                                return $(document).height() - $floatingProductsWrapper.offset().top - $floatingProductsWrapper.outerHeight()
                            }
                        }
                    });
                    // $(window).trigger('scroll');
                }, 2000);
            };

            initSwiper();
            affixFloatingProductsWrapper();

            const resizeObserver = new ResizeObserver(function () {
                affixFloatingProductsWrapper();
            });
            resizeObserver.observe(document.body);

            $(window).resize(function() {
                swiperFloating.destroy();
                initSwiper();
            });
        }

        /**
         * Ações relacionadas à galeria de imagens do produto
         */

        // Inicializa cada galeria ao Gerenciador de Galerias
        $('[data-gallery-id]').each(function (i, element) {
            QPGalleryManager.addGallery($(element).data('gallery-id'));
        });

        // Inicializa a galeria por popup (com PhotoSwipe)
        $(document).on('click', '.openGalleryPhotoSwipe', function () {
            var psGalleryId = $(this).data('gallery-id');
            var $element = $('.gallery-photo-swipe[data-gallery-id="' + psGalleryId + '"]');
            QPPhotoSwipe.create($element, {index: QPGalleryManager.getCurrentIndex(psGalleryId)}).init();
        });

        // Inicializa todas as galerias
        var _initGalleryPlugins = function () {

            // Desabilita o evento click da galeria vertical
            $('.swiper-gallery-products .swiper-slide').on('click', 'a', function (e) {
                e.preventDefault();
            });

            // Inicializa o caroussel das fotos maiores (OwlCarousel)
            var $owlFotosSelector = $(".owl-fotos");
            $owlFotosSelector.each(function (key, gallery) {
                $(gallery).find('.item').on('click', 'a', function (e) {
                    if ($(window).width() <= 992) {
                        e.preventDefault();
                        var psGalleryId = $(gallery).data('gallery-id');
                        var $element = $('.gallery-photo-swipe[data-gallery-id="' + psGalleryId + '"]');
                        QPPhotoSwipe.create($element, {index: QPGalleryManager.getCurrentIndex(psGalleryId)}).init();
                    }
                });
                QPOwlGallery.init($(gallery));
            });


            initSwiperGallery();

            // Inicializa o Zoom das imagens
            QPEasyZoom.init($(".easyzoom"));


            // Thumb horizontal
            var owlThumbs = $(".owl-fotos-miniaturas");
            owlThumbs.owlCarousel({
                itemsDesktop: [1024, 5],
                itemsDesktopSmall: [991, 5],
                itemsTablet: [768, 4],
                itemsMobile: [479, 4],
                navigation: true,
                navigationText: false,
                addClassActive: true,
                rewindNav: false,
                pagination: false,
                afterAction: function () {
                    setTimeout(function () {
                        var $item = owlThumbs.find('.item:not(.video):first');
                        if ($item.length > 0) {
                            var height = $item.height();
                            owlThumbs.find('.item.video').css('height', (height + 'px'));
                        }
                    }, 100);
                }
            });

            owlThumbs.on('click', '.owl-item', function (e) {
                if ($(this).data('lightbox') == 'iframe') {
                    return;
                }

                e.preventDefault();
                var index = $(this).data("owlItem");
                var galleryId = $(this).parents('[data-gallery-id]').data('gallery-id');
                QPGalleryManager.setCurrentIndex(galleryId, index);
            });

            var numeroDeVideos = owlThumbs.find('.item.video').length;
            QPGalleryManager.setCurrentIndex(owlThumbs.data('gallery-id'), numeroDeVideos);
        }

        _initGalleryPlugins();


        /**
         * Abre o box de avaliação após o cliente efetuar o login e ser redirecionado à
         * tela de detalhes do produto novamente.
         */
        if (window.location.hash == '#box-avalie') {
            initLightbox('.btn._avaliacao', {open: true});
        }

        initLightbox();
        initPicture();
        initRating();
        showBuyButton();

        $('.form-product-detail').on('click', '.box-color div:not(.variation-selected), .box-color img:not(.variation-selected)', function () {

            var cor = encodeURIComponent($(this).data('title'));
            var $form = $(this).closest('.form-product-detail');
            var produtoid = $form.data('produto-id');

            $form.find('.box-color .variation-selected').removeClass('variation-selected');
            $(this).addClass('variation-selected');

            $.ajax({
                url: window.root_path + '/produtos/actions/detalhes_produto/color-grade-pictures.php',
                type: 'POST',
                data: 'cor=' + cor + '&produtoid=' + produtoid,
                beforeSend: function () {
                    $('.gallery').block({message: '<h1>Carregando...</h1>'});
                },
                complete: function () {
                    $('.gallery').unblock();
                },
                success: function (response) {
                    if (response) {

                        $.each(response, function (produtoId, values) {

                            // Atualiza os valores que mudam de acordo com a variação
                            $.each(values.data_content_id, function (id, value) {

                                var $content = $('[data-content-id="' + id + '"]');

                                if ($content.hasClass('owl-carousel')) {
                                    $content.parent().css({
                                        'min-height': $content.parent().height() + 'px',
                                        overflow: 'hidden'
                                    });
                                }

                                if ($content.length > 0) {
                                    $content.html(value);

                                    if ($content.hasClass('owl-carousel')) {
                                        $content.data('owlCarousel').reinit();
                                        $content.parent().css('height', 'auto');
                                    }
                                }
                            });

                            initSwiperGallery();
                            QPEasyZoom.init($(".easyzoom"));

                        });

                        initLazyLoad();
                        initPicture();
                    }
                }
            });
        });
    }


    /**
     * @type {*|jQuery|HTMLElement}
     */
    var $formAtributosSelecionados = $('#form-atributos-selecionados');
    if ($formAtributosSelecionados.length == 0) {
        $formAtributosSelecionados = $('<form>').attr('id', '#form-atributos-selecionados');
        $('body').prepend($formAtributosSelecionados);
    }

    var fnAtualizaAtributosSelecionados = function () {

        $('.variation[data-selected="true"]').each(function (i, select) {

            var produtoId = $(this).data('produto-id');
            var produtoAtributoId = $(select).data('attribute');
            var variacao;

            if ($(this).is('select')) {
                variacao = $(select).find('option:selected').text();
            } else {
                variacao = $(select).val();
            }

            var name = 'opcoes[' + produtoId + '][' + produtoAtributoId + ']';
            var $input = $formAtributosSelecionados.find('[name="' + name + '"]');

            if ($input.length == 1) {
                $input.val(variacao);
            } else {
                $input = $('<input>').attr({
                    type: 'hidden',
                    name: name
                });
                $input.appendTo($formAtributosSelecionados);
            }

            $input.val(variacao);

        });

    }

    /**
     * Para cada variação pré-selecionada, preenche a variável que possui o mapeamento das variações
     * pré-selecionadas pelo sistema.
     */
    fnAtualizaAtributosSelecionados();

    /**
     * Controlando os eventos das variações:
     * A cada mudança, o sistema verificará as opções disponiveis de acordo
     * com as opções que já foram selecionadas
     */
    $(document).on('change', '.variation', function () {

        var typeField = $(this).is('select') ? 'select' : 'input';
        var produtoId = $(this).data('produto-id');
        var $submitBtn = $('#buy-button-' + produtoId);
        var element = $(this);

        var backupValue = $submitBtn.html();
        var loadingHtml = "<span class='fa fa-spin fa-spinner'></span> Aguarde...";

        $submitBtn
            .attr('disabled', true)
            .html(loadingHtml)
        ;

        if (typeField == 'select') {
            $(this).attr('data-selected', ($(this).val() != ''));
        } else if (typeField == 'input') {
            var name = ($(this).attr('name'));
            $('[name="' + name + '"][data-produto-id="' + produtoId + '"]').removeAttr('data-selected');
            $(this).attr('data-selected', true);
        }

        // Cria um array com todos os atributos já selecionados
        // para que no server, o php saiba quais atributos faltam
        // ser preenchidos.
        fnAtualizaAtributosSelecionados();

        if (pageName != 'produto-detalhes') {
            $('.product-list').addClass('variation-loading');
        }

        // Faz a requisição solicitando as variações que ainda não foram selecionadas
        // com base nas que já foram selecionadas.
        $.ajax({
            url: window.root_path + '/produtos/actions/variacao.php',
            dataType: 'json',
            data: {atributos: $formAtributosSelecionados.serialize(), produto_id: produtoId},
            type: 'POST',
            success: function (response) {

                $.each(response, function (produtoId, values) {

                    // Atualiza os valores que mudam de acordo com a variação
                    $.each(values.data_content_id, function (id, value) {

                        var $content = $('[data-content-id="' + id + '"]');

                        if ($content.hasClass('owl-carousel')) {
                            $content.parent().css({height: $content.parent().height(), overflow: 'hidden'});
                        }

                        if ($content.length > 0) {
                            $content.html(value);

                            if ($content.hasClass('owl-carousel')) {
                                $content.data('owlCarousel').reinit();
                            }

                            $content.parent().css('height', 'auto');
                        }
                    });

                    if (pageName == 'produto-detalhes') {
                        initSwiperGallery();
                        // Inicializa o Zoom das imagens
                        QPEasyZoom.init($(".easyzoom"));
                    }

                    // Atualiza a variação de acordo com a variação selecionada
                    $('[name*="quantidade_pv[' + produtoId + ']"]').attr('name', 'quantidade_pv[' + produtoId + '][' + values.produto_variacao_id + ']');

                });

                initLazyLoad();

                if (pageName == 'produto-detalhes') {
                    initPicture();
                    //_initGalleryPlugins();
                } else {
                    var quickview = element.closest('.quick-view');
                    $('html, body').animate({scrollTop: element.closest('.product').offset().top - 80}, 600);
                    quickview.focus().addClass('active');
                    $('.product-list').removeClass('variation-loading');

                }

                $submitBtn.html(backupValue).prop('disabled', false);
            }
        });
    });

    // console.log($('.variation:checked'));
    // console.log($('.variation:checked:first-child'));
    // $('.variation:checked:first-child').trigger('change');

    /**
     * Conjuntos de funções para adicionar ao carrinho por ajax
     * @type {*|jQuery|HTMLElement}
     */


    formAjaxAdicionarAoCarrinho($('.form-ajax-adicionar-ao-carrinho'));


    $('.product-info').on('click', '.add-to-cart-variation', function (e) {
        e.preventDefault();
        var url = $(this).data('href');
        openMagnificPopupIframe(url);
    });

    $('body').on('click', '.btn-action-comprar-junto', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        openMagnificPopupIframe(url);
    });

    var tooltips = document.querySelectorAll('.tooltip-preview span');
    window.onmousemove = function (e) {
        var x = (e.clientX + 20) + 'px',
            y = (e.clientY + 20) + 'px';
        for (var i = 0; i < tooltips.length; i++) {
            tooltips[i].style.top = y;
            tooltips[i].style.left = x;
        }
    };

});

/**
 * Função que oculta o botão "Filtrar" nas opções de características e acrescenta
 * o recurso click and submit.
 * Para habilitar este recurso, basta chamar esta função: clickAndSubmitFilters();
 */
function clickAndSubmitFilters() {
    $('#product-filters-wrapper :submit:not(.btn-submit-price)').hide();
    $('body').on('change', '#product-filters-wrapper :checkbox', function (e) {
        if ($(this).attr("name") != 'SomentePromocao') {
            $(this).submit();
        }
    });

    $('body').on('click', '#product-filters-wrapper .variation-other', function (e) {
        var radio = $(this).prev();

        if (radio.prop("checked")) {
            radio.prop("checked", false);
        } else {
            radio.prop("checked", true);
        }

        $(radio).submit();
    });
}

function initSwiperGallery() {
    // Inicializa a galeria vertical (Swiper)
    QPVerticalGallery.init($('.swiper-gallery-products'));
}

var QPEasyZoom = (function () {

    var _init = function (el) {
        _resize(el);
        $(window).resize(function () {
            _resize(el)
        });
    }

    var _resize = function (el) {
        if ($(window).width() >= 992) {
            el.each(function (i, v) {
                $(this).easyZoom();
            })
        } else {
            el.each(function (i, v) {
                apiEazyZoom = $(this).easyZoom().data('easyZoom').teardown();
            })
        }
    }

    return {
        init: _init,
    }

})();

/**
 * QPGalleryManager
 * @type {{currentIndex, setCurrentIndex}}
 */
var QPGalleryManager = (function () {

    var _collGalleries = {};

    var _updateIndexInPlugins = function (gallery) {

        index = gallery.currentIndex;

        if (QPVerticalGallery.getInstance(gallery.galleryId)) {
            QPVerticalGallery.getInstance(gallery.galleryId).swipeTo(index - 1, 300, '');
        }

        QPOwlGallery.goTo(gallery);

    }

    var _addGallery = function (galleryId) {

        if (_collGalleries[galleryId] == undefined) {
            _collGalleries[galleryId] = {
                galleryId: galleryId,
                currentIndex: 1,
            };
        }
    }

    var _getCurrentIndex = function (galleryId) {
        var gallery = _getGalleryById(galleryId);
        if (gallery) {
            return gallery.currentIndex;
        }
        return false;
    }
    var _setCurrentIndex = function (galleryId, index) {
        var gallery = _getGalleryById(galleryId);
        if (gallery) {
            gallery.currentIndex = index;
            _updateIndexInPlugins(gallery);
        }
        return false;
    }

    var _getGalleryById = function (galleryId) {
        if (_collGalleries[galleryId] != undefined) {
            return _collGalleries[galleryId];
        }
        return false;
    }

    return {
        addGallery: _addGallery,
        getCurrentIndex: _getCurrentIndex,
        setCurrentIndex: _setCurrentIndex
    };

})();

/**
 *
 * @returns {boolean}
 */
function detectIE() {
    var ua = window.navigator.userAgent;
    var old_ie = ua.indexOf('MSIE ');
    var new_ie = ua.indexOf('Trident/');

    return ((old_ie > -1) || (new_ie > -1));
}

var QPOwlGallery = (function () {

    var _instance = {};

    var _init = function (jqueryContainer, options) {
        jqueryContainer.each(function (i, element) {

            var numeroDeFotos = (detectIE() === false && $(element).data('count-item') > 1) ? 2 : 1;

            $(element).owlCarousel($.extend({
                //singleItem : true,
                items: numeroDeFotos,

                itemsDesktop: [2000, numeroDeFotos],
                itemsDesktopSmall: [1199, 1],
                itemsTablet: false,
                itemsMobile: false,
                navigation: ($(window).width() <= 768),
                pagination: false,
                navigationText: ['', ''],
                autoHeight: true,
                lazyLoad: true,
                afterInit: _resizeOwlFotos,
                afterAction: function () {
                    QPGalleryManager.setCurrentIndex($(element).data('gallery-id'), this.owl.currentItem);
                    _resizeOwlFotos();
                }
            }, options));

            _instance[$(element).data('gallery-id')] = {
                element: $(element),
                dataOwl: $(element).data('owlCarousel')
            };
        });

        return _instance;
    }

    var _resizeOwlFotos = function () {
        if (_instance.length > 0) {
            if ($(window).width() >= 992) {
                $(_instance).each(function (i, gallery) {
                    gallery.element.find('.owl-controls').hide();
                });
            } else {
                $(_instance).each(function (i, gallery) {
                    gallery.element.find('.owl-controls').show();
                });
            }
        }
    }

    var _getInstance = function (galleryId) {
        if (_instance[galleryId] != undefined) {
            return _instance[galleryId];
        }
        return false;
    }

    var _goTo = function (gallery) {
        if (_getInstance(gallery.galleryId)) {
            /**
             * Controle para saber se há vídeos nas galerias de thumbs.
             * Caso houver, precisamos identificar quando eles são clicados
             * para não mecher na galeria principal.
             */
            var quantidadeFotos = _getInstance(gallery.galleryId).dataOwl.itemsAmount;
            var thumbClicado = gallery.currentIndex + 1;
            if (thumbClicado <= quantidadeFotos) {
                _getInstance(gallery.galleryId).dataOwl.goTo(gallery.currentIndex);
            }
        }
    }

    return {
        init: _init,
        getInstance: _getInstance,
        goTo: _goTo
    }

})();

/**
 * QPVerticalGallery
 * @type {{init, instance}}
 */
var QPVerticalGallery = (function () {

    var _productThumbnailsSwiper = {};

    var _init = function (jqueryContainer, options) {

        var galleryId = (jqueryContainer).data('gallery-id');
        _productThumbnailsSwiper[galleryId] = jqueryContainer.swiper($.extend({
            mode: 'vertical',
            slidesPerView: 'auto',
            watchActiveIndex: true,
            mousewheelControl: true,
            nextButton: '.arrows.down',
            prevButton: '.arrows.up',
            onSlideClick: function () {
                QPGalleryManager.setCurrentIndex(galleryId, _productThumbnailsSwiper[galleryId].clickedSlideIndex);
            },
            onInit: function (swiper) {
                var countSlides = swiper.slides.length;
                if (countSlides > 3) {
                    $(swiper.container).parent().find('.arrows.up, .arrows.down').show();
                }
            },
        }, options));

        jqueryContainer.parent().find('.arrows.up').on('click', function () {
            _productThumbnailsSwiper[galleryId].swipePrev();
        });

        jqueryContainer.parent().find('.arrows.down').on('click', function () {
            _productThumbnailsSwiper[galleryId].swipeNext();
        });
        return _productThumbnailsSwiper;
    };

    var _getInstance = function (galleryId) {
        if (_productThumbnailsSwiper[galleryId]) {
            return _productThumbnailsSwiper[galleryId];
        }
        return false;
    };

    return {
        init: _init,
        getInstance: _getInstance
    }

})();

/**
 * PhotoSwipe
 * @type {{init}}
 */
var QPPhotoSwipe = (function () {

    var _pswp = null;

    var _create = function (jqueryElementGallery, options) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = _parseThumbnailElements(jqueryElementGallery);
        var defaultOptions = _defaultOptions();
        var options = $.extend(defaultOptions, options);

        _pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        _pswp.listen('beforeChange', function () {
            QPGalleryManager.setCurrentIndex(_pswp.getCurrentIndex());
        });

        return _pswp;
    }

    var _openGallery = function () {
        _pswp.init();
    };

    var _getInstance = function () {
        return _pswp;
    };

    var _defaultOptions = function () {
        return {
            mainClass: 'pswp--minimal--dark',
            barsSize: {
                top: 0,
                bottom: 0
            },
            captionEl: false,
            fillscreenEl: false,
            shareEl: false,
            bgOpacity: 0.85,
            tapToClose: true,
            tapToToggleControls: false
        }
    };

    var _parseThumbnailElements = function (jqueryElementGallery) {

        var $nodes = jqueryElementGallery.find('a');
        var items = [];

        $nodes.each(function (i, el) {
            childElements = el.children;
            size = el.getAttribute('data-size').split('x');

            item = {
                src: el.getAttribute('href'),
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10)
            };

            item.o = {
                src: item.src,
                w: item.w,
                h: item.h
            };

            items.push(item);
        });

        return items;
    };

    return {
        create: _create,
        openGallery: _openGallery,
        getInstance: _getInstance
    };

})();

$(function () {

    if (pageName === "parceiro_acesso") {
        $("#carousel-banner").owlCarousel({
            navigation: false,
            slideSpeed: 300,
            paginationSpeed: 400,
            singleItem: true,
            autoPlay: 4000,
            lazyLoad: true,
            pagination: true,
            navigationText: false
        });
    }

    if (pageName === "parceiros") {
        var $grid = $('.grid').isotope({
            itemSelector: '.grid-item',
            stagger: 30
        });

        $('.filter-button-group').on('click', 'button', function () {
            var filterValue = $(this).attr('data-filter');
            $grid.isotope({filter: filterValue});
        });

        $('.button-group button').on('click', function () {
            $('.button-group button.btn-theme').removeClass('btn-theme').addClass('btn-default');
            $(this).removeClass('btn-default').addClass('btn-theme');
        });
    }
});